<section class="passport-page mt-3 text-black dark:!text-white">
  <a routerLink="/" class="text-blue-500 hover:text-blue-400">&#8592; Back</a>
  <div #offerHost class="passport-offer-host"></div>
</section>
